import { maskZipCode } from './masks';

/**
 * Normaliza resposta de GET /api/enderecos/:id/por-id para exibição
 * (mesmo mapeamento usado em EmployeeForm após addressService.getById).
 * @param {Object|null|undefined} api
 * @returns {Object|null}
 */
export function mapAddressFromApi(api) {
    if (!api || typeof api !== 'object') return null;
    return {
        name: api.name ?? '',
        zipCode: api.zipCode ?? '',
        street: api.street ?? '',
        number: api.number != null && api.number !== '' ? String(api.number) : '',
        complement: api.complement ?? '',
        district: api.district ?? '',
        city: api.city ?? '',
        stateAbbr: api.state?.abbreviation ?? '',
        stateName: api.state?.name ?? '',
        addressId: api.id ?? null,
    };
}

/**
 * CEP para leitura (máscara ou em dash).
 * @param {string|number|null|undefined} raw
 * @returns {string}
 */
/**
 * Endereço operacional da entrega a partir de DTO da API (solicitante, template, etc.).
 * Não inclui id, template nem customerId — a entrega grava endereço próprio.
 * @param {Object|null|undefined} api
 * @returns {Object|null}
 */
export function mapOperationalAddressFromApi(api) {
    const mapped = mapAddressFromApi(api);
    if (!mapped) return null;
    const digits = String(mapped.zipCode || '').replace(/\D/g, '');
    return {
        name: mapped.name || '',
        zipCode: digits.length ? maskZipCode(digits) : '',
        street: mapped.street,
        number: mapped.number,
        complement: mapped.complement,
        district: mapped.district,
        city: mapped.city,
        stateAbbr: mapped.stateAbbr,
        stateName: mapped.stateName,
    };
}

export function formatZipDisplay(raw) {
    if (raw == null || raw === '') return '—';
    const d = String(raw).replace(/\D/g, '');
    return d.length ? maskZipCode(d) : '—';
}
